import type { FigmaIconProps } from './types';

export const IconFigmaSelectArrow = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.62307 6.37705C3.41479 6.16877 3.41479 5.83142 3.62307 5.62314C3.83135 5.41486 4.1687 5.41486 4.37698 5.62314L8.00002 9.24619L11.6231 5.62314C11.8313 5.41486 12.1687 5.41486 12.377 5.62314C12.5853 5.83142 12.5853 6.16877 12.377 6.37705L8.37698 10.377C8.1687 10.5853 7.83135 10.5853 7.62307 10.377L3.62307 6.37705Z"
      fill={color}
    />
    <path
      d="M3.48183 6.51828C3.19545 6.2319 3.19545 5.76821 3.48183 5.48183C3.76822 5.19548 4.23192 5.19546 4.51829 5.48183L8.00006 8.9636L11.4818 5.48183C11.7682 5.19548 12.2319 5.19546 12.5183 5.48183C12.8047 5.7682 12.8046 6.2319 12.5183 6.51828L8.51829 10.5183C8.23191 10.8047 7.76822 10.8047 7.48183 10.5183L3.48183 6.51828ZM3.76439 5.76438C3.63421 5.89455 3.63421 6.10556 3.76439 6.23573L7.76439 10.2357C7.89456 10.3659 8.10557 10.3659 8.23574 10.2357L12.2357 6.23573C12.3659 6.10555 12.3659 5.89454 12.2357 5.76438C12.1056 5.63422 11.8946 5.63424 11.7644 5.76438L8.14134 9.38743C8.06323 9.46553 7.93689 9.46553 7.85879 9.38743L4.23574 5.76438C4.10558 5.63422 3.89456 5.63424 3.76439 5.76438Z"
      fill={color}
    />
  </svg>
);
